export default __webpack_public_path__ + "static/media/d1.569c6002.svg";